import { Button, Text } from '@elladx/design-system';
import { useEffect, useRef } from 'react';
import Modal from './Modal';
import type { OrderHistoryEntry } from '../types';
interface CancelShipmentModalProps {
    isOpen: boolean;
    loading: boolean;
    order: OrderHistoryEntry | null;
    errorMessage?: string;
    onClose: () => void;
    onConfirm: () => void;
}
function CancelShipmentModal({ isOpen, loading, order, errorMessage = '', onClose, onConfirm }: CancelShipmentModalProps) {
    const errorRef = useRef<HTMLElement | null>(null);
    useEffect(() => {
        if (isOpen && errorMessage)
            errorRef.current?.scrollIntoView({ block: 'nearest' });
    }, [isOpen, errorMessage]);
    return (<Modal isOpen={isOpen} onClose={onClose} title="Request a label refund?" dismissible={!loading}>
      <Text style={{ marginBottom: '20px' }}>
        The carrier reviews refund requests. A refund is complete only after the carrier confirms it.
      </Text>
      {order && (<div style={{
                background: 'var(--dx-color-sage)',
                padding: '16px',
                marginBottom: '20px'
            }}>
          <div>
            <strong>Recipient:</strong> {order.recipient}
          </div>
          <div>
            <strong>Tracking:</strong> {order.tracking_code || '-'}
          </div>
        </div>)}
      {errorMessage && <Text ref={errorRef} role="alert" tone="error" style={{ color: 'var(--dx-color-error)', marginBottom: '20px' }}>{errorMessage}</Text>}
      <div className="dialog-actions">
        <Button onClick={onClose} disabled={loading} variant="ghost" type="submit">
          Keep label
        </Button>
        <Button onClick={onConfirm} disabled={loading} variant="danger-secondary" type="submit" isLoading={loading}>
          {loading ? 'Submitting refund request…' : 'Request refund'}
        </Button>
      </div>
    </Modal>);
}
export default CancelShipmentModal;
